export default {
  students: [],
  student: {}
}
